import { GetFinesListByCarPlate } from "../services/FinesServices";
import { useFinesStore } from "../../../store";



export const useFines = () => {
  const { trafficTickets, onFillFines, onRestFines } = useFinesStore();

  const getFinesListByCarPlate = async (CarPlate: string) => {
   
    try {
      const fines = await GetFinesListByCarPlate(CarPlate);
      console.log(fines.error)
      // Verificar si el backend devolvi� un error
      if (fines.error) {
        

        
        if (fines.error === "EnProceso") {
          return "EnProceso"
        } else if (fines.error === "Pagado") {
          return "Pagado";
        } else if (fines.error === "Error"|| undefined) {
          return "Error";
        }else if (fines.error === "Bloqueado"){
          return "Bloqueado"
        }else {
          alert("Ocurri� un error inesperado.");
        }

        return; // Salir de la funci�n sin actualizar el estado
      }

      // Si no hay error, actualizar el estado con las multas
      onFillFines(fines);
    } catch (e) {
      console.log("Error en la petici�n:", e);
      
    }
  };

      // Limpiar el estado de multas antes de buscar nuevas
  const onResetFines = () => {
    onRestFines(); // Actualizar el estado con las multas obtenidas
  };
  return {
    trafficTickets,
    getFinesListByCarPlate,
    
    onResetFines
  };
};

